// extracted by mini-css-extract-plugin
export default {"warning":"styles_warning__biXoZ","wrapper":"styles_wrapper__5M1FC","message_style":"styles_message_style__GBlCa","text":"styles_text__8fC+p"};